import {
    SETTINGS_LIST_FAIL,
    SETTINGS_LIST_REQUEST,
    SETTINGS_LIST_SUCCESS, SETTINGS_UPDATE_DETAILS_RESET, SETTINGS_UPDATE_FAIL,
    SETTINGS_UPDATE_REQUEST, SETTINGS_UPDATE_SUCCESS
} from "../constants/settingsConstants";

export const settingsListReducer = (state = {}, action) => {
    switch(action.type){
        case SETTINGS_LIST_REQUEST:
            return { loading: true}
        case SETTINGS_LIST_SUCCESS:
            return { loading: false, settingsList: action.payload };
        case SETTINGS_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
}

export const settingsUpdateReducer = (state = { settings : {} }, action) => {
    switch (action.type){
        case SETTINGS_UPDATE_REQUEST:
            return { loading: true, success: false };
        case SETTINGS_UPDATE_SUCCESS:
            return { loading: false, settingsList: action.payload, success: true};
        case SETTINGS_UPDATE_FAIL:
            return {loading: false, error: action.payload, success: false};
        case SETTINGS_UPDATE_DETAILS_RESET:
            return {loading: false, error: null, success: false}
        default:
            return state;
    }
}
